import { vn_app_zone_notification } from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {XMLHttpRequestHandler_requestType} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler"
import {txnInitSplitView_template} from "../components/templates/txnInitSplitView_template";

declare var ko: any;
declare var page: any;

export class txnInitSplit_view extends vnModule_knockoutJS{

    protected XHRHdl: XMLHttpRequestHandler;
    protected txnInitSplitView: txnInitSplitView_template;

    protected getModuleName(){
        return "txnInitSplit_view";
    }

    buildContent() : Array<Element> {
        this.txnInitSplitView = new txnInitSplitView_template("txnInitSplitView_template", this.viewModel, this);
        return [this.txnInitSplitView.build()];
    }
    //
    // fill the page at first load.
    fillPage(): void {

        this.getReferences();
    }


    protected cancelViewTxnInitSplit(){

        // redirect to earnings page or user list
        this.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_WARNING, "Transaction intitiative split action canceled !");

        page.redirect('/txn_init_split');
    }

    protected editTxnInitSplit(){
        if(this.getVnAppZone().app.params.idBrand != undefined && this.getVnAppZone().app.params.idUser != undefined) {

            let idBrand = this.getVnAppZone().app.params.idBrand;
            let idUser = this.getVnAppZone().app.params.idUser;
            // redirect to earnings page or user list
            page('/txn_init_split/brand/' + idBrand + '/user/' + idUser + '/edit');
        }
    }

    // Getting role data from server.
    public getFormData(): void {

        if(this.getVnAppZone().app.params.idBrand != undefined && this.getVnAppZone().app.params.idUser != undefined) {

            let idBrand = this.getVnAppZone().app.params.idBrand;
            let idUser = this.getVnAppZone().app.params.idUser;


            this.loadingIn(this.txnInitSplitView.builtTemplate.children.namedItem("view-results"));

            let usrReq_url: string = '/api/txn_init_split/brand/' + idBrand + '/user/' + idUser + '/get/';
            let usrReq_params: Array<Array<string>> = [];

            this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

            this.XHRHdl.onReadyStateFunction = this.onGetTxnInitSplitDataReturn;
            this.XHRHdl.execute();
        }



    }

    // Handling response data.
    protected onGetTxnInitSplitDataReturn(req, obj): Function {

        return function () {
            obj.manageResponse(req, obj, function () {
                let response = JSON.parse(req.request.response);
                obj.txnInitSplitView.setBrand(response.brand);
                obj.txnInitSplitView.setUser(response.user);
                obj.txnInitSplitView.setInitiativeSplits(response.initiativeSplits);


                obj.loadingOut(obj.txnInitSplitView.builtTemplate.children.namedItem("view-results"));

            });
        }
    }


    private getReferences(): void {

        this.loadingIn(this.txnInitSplitView.builtTemplate.children.namedItem("view-results"));

        let usrReq_url: string = '/api/txn_init_split/references/';
        let usrReq_params: Array<Array<string>> = [];

        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetReferencesDataReturn;
        this.XHRHdl.execute();
    }


    private onGetReferencesDataReturn(req, obj): Function {
        return function () {
            obj.manageResponse(req, obj, function () {
                let response = JSON.parse(req.request.response);
                obj.updateReferences(response);
                obj.loadingOut(obj.txnInitSplitView.builtTemplate.children.namedItem("view-results"));

                obj.getFormData();
            });


        }
    }

    protected updateReferences(response): void {

        this.txnInitSplitView.setInitiatives(response.initiatives);
    }

}



// WEBPACK FOOTER //
// ./js/modules/txnInitSplit_view.ts